const getTimezoneAbbreviation = timezone => {
  const timezones = {
    'Asia/Tokyo': 'JST', // Japan Standard Time
    'Asia/Manila': 'PHT', // Philippine Standard Time
    'Asia/Malaysia': 'MYT', // Indian Standard Time
    'Asia/Singapore': 'SGT', // Singapore Time
  };

  return timezones[timezone] || timezone;
};

export default getTimezoneAbbreviation;
